// Wires Core Web Vitals → Sentry custom metrics.
// Call initWebVitals() once after Sentry.init() in main.jsx.
// Each metric is recorded as a distribution so Sentry can show p50/p75/p95.

import { onLCP, onINP, onCLS, onFCP, onTTFB } from 'web-vitals'
import * as Sentry from '@sentry/react'

function record(metricName) {
  return ({ value }) => {
    if (!Sentry.metrics?.distribution) return
    Sentry.metrics.distribution(`web_vitals.${metricName.toLowerCase()}`, value, {
      unit: metricName === 'CLS' ? 'none' : 'millisecond',
      tags: { page: window.location.pathname.split('/')[1] || 'root' },
    })
  }
}

export function initWebVitals() {
  onLCP(record('LCP'))
  onINP(record('INP'))
  onCLS(record('CLS'))
  onFCP(record('FCP'))
  onTTFB(record('TTFB'))
}
